'use client'

import { type HTMLAttributes } from 'react'

import { useCart } from '@src/hooks/useCart'
import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

interface Props {
  children: React.ReactNode
  attributes: HTMLAttributes<HTMLDivElement> & { key: string }
  className?: string
  skusInOut: boolean
  anyOrAll: 'Any' | 'All'
  skus: string[]
}

const skuLabel = (skus: string[], skusInOut: boolean, anyOrAll: string) => {
  let string = ' SKU Conditional: '
  string += '' + skusInOut + ', '
  skus.forEach((sku: string) => {
    string += ` ${sku},`
  })
  string += ' ' + anyOrAll
  return (
    <div className="pointer-events-none absolute top-0 right-9 z-50 bg-red-600 px-2 py-4 text-body-base text-black opacity-70">
      {string}
    </div>
  )
}

export function SKUinCartConditionalContent(props: Props) {
  const cart = useCart()
  const { attributes, className, skus, skusInOut, anyOrAll, children } = props
  const { edit } = getBuilderPreviewMode()
  let showContent: boolean = false

  /*
    First, determine if we are showing content if SKU is in cart or not.
    then determine if we are showing it for Any or All SKUs,
    then determine if sku is in array.
    Set showContent to true if we are showing content based on above variables.
  */

  /* Checks for a SKU in the cart. */
  const hasSkuInCart = (sku: string): boolean => {
    let hasSku: boolean = false
    hasSku =
      cart.cart?.lineItems?.some((item: any) => {
        return item.variant.sku === sku
      }) ?? false

    return hasSku ?? false
  }

  let hasSKU: boolean = false
  if (skus !== undefined && skus.length > 0) {
    if (anyOrAll === 'Any') {
      skus?.some((sku: string) => {
        if (hasSkuInCart(sku)) {
          hasSKU = true
        }
        // returns true if any of the SKUS are in the cart
      })
    } else {
      // only show if ALL are there.
      hasSKU = skus?.every((sku: string) => {
        return hasSkuInCart(sku)
      })
      // returns true if ALL of the SKUS in showIfSkuInCart are in the cart
    }
  }
  showContent = skusInOut === hasSKU

  const content = (
    <div
      {...attributes}
      key={attributes?.key}
      className={cn('size-auto', className, attributes?.className, {
        'border-4 border-red-300 relative': edit,
        'opacity-50': !showContent && edit,
      })}
      style={{ ...attributes?.style }}
      suppressHydrationWarning
    >
      {/* Adds experiment label in edit mode */}
      {edit && skuLabel(skus, skusInOut, anyOrAll)}
      {children}
    </div>
  )
  if (edit || showContent) return content

  return null
}
